export var TipoAtendimentoEnum;
(function (TipoAtendimentoEnum) {
    TipoAtendimentoEnum["NAO_TEM"] = "NAO_TEM";
    TipoAtendimentoEnum["PRESENCIAL"] = "PRESENCIAL";
    TipoAtendimentoEnum["ONLINE"] = "ONLINE";
})(TipoAtendimentoEnum || (TipoAtendimentoEnum = {}));
